import type { GetExternalFeedbackResponse, JsonObject } from '@/app-package';
import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

export type GetExternalFeedbackOptions = {
  dashboardId: string;
  appointmentId: string;
};

export type ExternalFeedback = JsonObject<GetExternalFeedbackResponse>;

const getExternalFeedback = async ({
  dashboardId,
  appointmentId,
}: GetExternalFeedbackOptions) => {
  const config: AxiosRequestConfig = {
    url: `/external/dash/${dashboardId}/feedback/${appointmentId}`,
    method: 'get',
  };

  const { data } = await axios.request<ExternalFeedback>(config);

  return data;
};

export default getExternalFeedback;
